export const overrideExtendedPalette = {
    '--wix-color-29': 'var(--wix-color-3)',
    '--wix-color-37': 'var(--wix-color-5)',
    '--wix-color-38': 'var(--wix-color-8)',
    '--wix-color-39': 'var(--wix-color-8)',
    '--wix-color-40': 'var(--wix-color-1)',
    '--wix-color-41': 'var(--wix-color-8)',
    '--wix-color-42': 'var(--wix-color-8)',
    '--wix-color-43': 'var(--wix-color-1)',
    '--wix-color-44': 'var(--wix-color-3)',
    '--wix-color-45': 'var(--wix-color-3)',
    '--wix-color-46': 'var(--wix-color-1)',
    '--wix-color-47': 'var(--wix-color-1)',
    '--wix-color-48': 'var(--wix-color-8)',
    '--wix-color-49': 'var(--wix-color-8)',
    '--wix-color-50': 'var(--wix-color-1)',
    '--wix-color-51': 'var(--wix-color-8)',
    '--wix-color-52': 'var(--wix-color-8)',
    '--wix-color-53': 'var(--wix-color-1)',
    '--wix-color-54': 'var(--wix-color-3)',
    '--wix-color-55': 'var(--wix-color-3)',
};
//# sourceMappingURL=constants.js.map